const SetSessionStrage = async () =>{
    // const token = localStorage.getItem('token');
    const token = sessionStorage.getItem('token');
    const getUsers = async() => {
        const sendRequest = async (url,data) => {
            const response = await fetch(url, {
                method: 'POST', // HTTPメソッド
                headers: {
                    'Content-Type': 'application/json', // コンテントタイプをJSONに指定
                },
                body: JSON.stringify(data), // JavaScriptオブジェクトをJSON文字列に変換
            });
            if (response.status === 200) {
                const body = await response.json(); // レスポンスボディをJSONオブジェクトに変換
                // console.log(body.system[0])
                sessionStorage.setItem("nickname", body.system[0].nickname);
                sessionStorage.setItem("email", body.system[0].email);
                sessionStorage.setItem("level", body.system[0].level);
            }
        };
        try {
            const data = { token }
            sendRequest(`${process.env.REACT_APP_API_USER}/token`,data);
        } catch (error) {
            console.error('Error:', error);
            window.location.reload();
        }
    };
    if(token){
        getUsers();
    }

    return;

}
export default SetSessionStrage;